export default "__VITE_ASSET__BcoQrHbU__"